import { Button } from "react-bootstrap";
import { useHrStyles } from "../../Context/HRContext";
import "./StructText.css";

export default function StructText() {
  const hrStyles = useHrStyles();
  return (
    <div className="Struct-text-container">
      <p
        style={{
          textAlign: "justify",
          fontSize: "1em",
          paddingLeft: "1em",
          paddingRight: "1em",
          fontFamily: "'Inria Serif', serif",
          padding: "0% 20%",
          paddingTop: "2em",
        }}
      >
        At BEAMS, our structural engineering services are built on a foundation
        of precision, innovation, and safety. We specialize in designing robust
        structural systems that ensure the integrity and durability of every
        project. Our engineers assess the unique requirements of each structure,
        selecting the most appropriate materials and techniques to achieve
        optimal performance. From residential to commercial buildings, we create
        strong, safe, and reliable frameworks that stand the test of time. With
        a focus on sustainability and cutting-edge technology, we deliver
        engineering solutions that not only meet but exceed industry standards.
      </p>
      <Button
        href="/Contact"
        variant="outline-danger"
        size="lg"
        className="centered-button"
      >
        Contact Us
      </Button>
      <hr style={hrStyles} />
      <div style={{ marginTop: "20px" }}></div>
    </div>
  );
}
